
import DefinitionConditionV from '../view/recordm.view.definition.condition.js';
import DefinitionFieldP from './recordm.presenter.definition.field.js';
import DefinitionFieldsNanny from './recordm.presenter.definition.fieldnanny.js';

// The Presenter for a field's specific condition
//
// This Presenter is unique in that it uses either the condition or a generated Id (if the condition is blank)
// to identify itself inside it's nanny.
var DefinitionConditionP = function(core, parent, condition, id, fields, readonly, callbacks) {

    var _nanny = new DefinitionFieldsNanny();
    var _fieldBuilder = new DefinitionFieldP.NewFieldBuilder(core, {expand: () => {
        view.expand()
        parent.expand();
    }});

    var view = DefinitionConditionV(core, undefined, {

        top_field_add: function(){
            var newField = _fieldBuilder.buildFor(_nanny);

            core.translate('recordm.definition', newField.content());

            view.addTopField(newField);
            _nanny.addChildAfter(0, newField);
        },

        top_field_drop: function($dropedElement){
            var oldNanny = $dropedElement.data('nanny');

            //remove the Presenter from the oldNanny
            var hisPresenter = oldNanny.removeChild($dropedElement.data('fieldId'));

            //set the new nanny, both in the Presenter and the data attribute
            hisPresenter.setNanny(_nanny);
            $dropedElement.data('nanny', _nanny);

            //add to our fields
            view.addTopField(hisPresenter);
            _nanny.addChildAfter(0, hisPresenter);
        },

        remove: function(){
            _nanny.empty();
            view.remove();

            callbacks.remove(id);
        }
    });

    var _getModel = function() {
        var fieldsModel = [];

        _nanny.getChildren().forEach(function(fieldP) {
            var model = fieldP.getFieldDef();

            if (view.getCondition()) {
                model.condition = view.getCondition();
            }
            fieldsModel.push(model);

        });

        return fieldsModel;
    };

    var _init = function() {
        view.build(condition, readonly);

        core.subscribe('expand-fields', function() {
             view.expand();
        });
        core.subscribe('collapse-fields', function() {
            view.collapse();
        });

        if (fields) {
            fields.forEach(function(field) {
                // var newFieldP = new DefinitionFieldP(core, parent, field, _nanny, readonly);
                var newFieldP = _fieldBuilder.buildFor(_nanny, field, readonly);
                _nanny.addChild(newFieldP);
                view.addField(newFieldP);
            })
        }
    };
    _init();

    return {
        getId: function (){
            return id;
        },
        content: function() {
            return view.getContainer();
        },
        focus: function() {
            view.focusConditionField();
        },

        showErrors: function(errors) {
            view.clearErrors();

            // deal with visibility errors of direct descendants
            for(const f of _nanny.getChildren()){
                const id = f.getId();
                if(errors[id]){
                    const filtered = errors[id].filter((e) => e.type.startsWith('Visibility_'));
                    if(filtered.length > 0 ){
                       view.showErrors(filtered);
                       parent.expand();
                       view.focusConditionField();
                    }
                }
            }

            _nanny.getChildren().forEach((p) => p.showErrors(errors));
        },

        getModel: _getModel
    }
};

export default DefinitionConditionP;
